module.exports = "#clientForm {\n  padding: 15px 0;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/clients/clients.component.css
// module id = ./src/app/components/clients/clients.component.css
// module chunks = main